<template>
    <div>
        <kgr-duplication-selection
            v-model="selection"
            label-prefix="child_contract_status"
            :filter-options="filterOptions"
            :kindergartens="kindergartens"
            class="kgr-row"
            @kindergartenSourceChanged="getChildrenForKindergartenSource"
            @kindergartenTargetChanged="getChildrenForKindergartenTarget"
        />

        <kgr-loading v-if="showLoading" />

        <kgr-empty-data
            v-else-if="selection.kindergartenSource === null"
            :value="$t('duplication.child.empty_data.no_kindergarten')"
        />
        <kgr-empty-data
            v-else-if="selection.kindergartenSource !== null && sourceChildren.length === 0"
            :value="$t('duplication.child.empty_data.filter')"
        />

        <kgr-duplication
            v-else-if="sourceChildren.length > 0"
            :source-elements="sourceChildren"
            :target-elements="targetChildren"
            :kindergarten-source="selection.kindergartenSource"
            :kindergarten-target="selection.kindergartenTarget"
            :filters="selection.filters"
            :in-progress="inProgress"
            :matching-function="(filters, element) => filters.indexOf(element.contractStatus) !== -1"
            type="child"
            @duplicate="duplicate($event)"
        >
            <template #header>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Status') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Vorname') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Nachname') }}
                </th>
            </template>
            <template #row="scope">
                <td class="kgr-table__cell">
                    <kgr-child-status-icon
                        :status="scope.element.contractStatus"
                        :title="$t('child_contract_status.' + scope.element.contractStatus)"
                        small
                    />
                </td>
                <td class="kgr-table__cell">
                    {{ scope.element.firstName }}
                </td>
                <td class="kgr-table__cell">
                    {{ scope.element.lastName }}
                </td>
            </template>
        </kgr-duplication>
    </div>
</template>

<script>
import ChildDuplicationRepository from '../../js/repository/ChildDuplicationRepository';
import ChildRepository from '../../js/repository/ChildRepository';
import ChildStatusIcon from '../child/contract/ChildStatusIcon.vue';
import Duplication from './Duplication';
import DuplicationSelection from './DuplicationSelection';
import EmptyData from '../common/EmptyData.vue';
import Loading from '../common/Loading.vue';

export default {
    components: {
        'kgr-duplication-selection': DuplicationSelection,
        'kgr-duplication': Duplication,
        'kgr-child-status-icon': ChildStatusIcon,
        'kgr-empty-data': EmptyData,
        'kgr-loading': Loading,
    },
    props: {
        federationId: {
            type: Number,
            required: true,
        },
        kindergartens: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selection: {
                filters: ['archived', 'active', 'waiting_for_contract_start', 'waiting_for_contract_signing', 'on_waiting_list', 'signed_up', 'created'],
                kindergartenSource: null,
                kindergartenTarget: null,
            },
            filterOptions: ['archived', 'active', 'waiting_for_contract_start', 'waiting_for_contract_signing', 'on_waiting_list', 'signed_up', 'created'],
            inProgress: false,
            sourceChildren: [],
            targetChildren: [],
            showLoading: false,
        }
    },
    methods: {
        duplicate(elements) {
            this.inProgress = true;
            ChildDuplicationRepository.duplicate(elements.map(element => element.id), this.selection.kindergartenTarget.id)
                .then(() => {
                    this.inProgress = false;
                    this.$notify.success('duplication.child.success');
                    this.getChildrenForKindergartenTarget(this.selection.kindergartenTarget);
                })
                .catch(() => {
                    this.$notify.error('duplication.child.error');
                    this.inProgress = false;
                });
        },
        getChildrenForKindergartenSource(kindergarten) {
            if (this.selection.kindergartenTarget !== null) {
                if (this.selection.kindergartenTarget.id === kindergarten.id) {
                    this.targetChildren = [];
                }
            }

            if (kindergarten === null) {
                this.sourceChildren = [];
            } else {
                this.showLoading = true;
                ChildRepository.findAllByKindergarten(kindergarten.id)
                    .then( children => {
                        this.sourceChildren = children;
                        this.showLoading = false;
                    })
                    .catch(() => {
                        this.$notify.error('duplication.child.source.error');
                        this.showLoading = false;
                    });
            }
        },
        getChildrenForKindergartenTarget(kindergarten) {
            if (kindergarten === null) {
                this.targetChildren = [];
            } else {
                this.inProgress = true;
                ChildRepository.findAllByKindergarten(kindergarten.id)
                    .then( children => {
                        this.targetChildren = children;
                        this.inProgress = false;
                    })
                    .catch(() => {
                        this.$notify.error('duplication.child.target.error');
                        this.inProgress = false;
                    });
            }
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
